import * as React from 'react';
import { observer } from 'mobx-react';
import { ActingRole, UserList } from '../../types';
import { useEffect, useState } from 'react';
import { useSetState } from 'react-use';
import { Acting } from '../../store/Acting';
import { Button, AutoComplete, TextHighlighter } from '@iba-team/portal-react-components/dist';
import { ReactComponent as DraftIcon } from '@iba-team/portal-react-components/dist/svg/outline/edit.svg';
import { ReactComponent as DeleteIcon } from '@iba-team/portal-react-components/dist/svg/outline/trash.svg';
import './ActingRole.scss';
import { useTranslation } from 'react-i18next';
interface RoleItemI{
  role: ActingRole
}

interface Query{
  userId: number,
  userName: string
}
export const RoleItem = observer((props: RoleItemI) => {
  const {getEmployeeList, addActing, updateActing, deleteActing} = Acting;
  const [query, setQuery] = useSetState<Query>({ userId: props.role.actingId, userName: props.role.actingName || '' });
  const [employeeList, setEmployeeList] = useState<UserList[]>([]);
  const [typingMode, setTypingMode] = useState(false);
  const {t} = useTranslation();

  useEffect(() => {
    getEmployeeList(props.role.roleId, query.userName).then(res => setEmployeeList(res.employees));
  },[typingMode, query.userName]);

  const isRoleIdExist = props.role.id !== null;
  const handleRole = () => {
    const requestBody = {...props.role, actingId: query.userId, actingName: query.userName};
    if(isRoleIdExist && query.userId){
      updateActing(requestBody);
    }
    if(!isRoleIdExist){
      addActing(requestBody);
    }
    setTypingMode(false);
  };

  const deleteRole = () => {
    if(props.role.id){
      setQuery({userName: '', userId: 0});
      deleteActing(props.role.id);
    }
  };

  return (
    <div>
      <div className={'role_name'}>{props.role.roleName}</div>
      {!isRoleIdExist && !typingMode &&
        <div className={'createActingLink'} onClick={() => setTypingMode(true)}>{t('acting_roles.assignActingBtn')}</div>
      }
      <div className={'role_actions'}>
        {(isRoleIdExist || typingMode) &&
          <AutoComplete<UserList> className={'autocomplete'} disabled={!typingMode}
            list={employeeList}
            placeholder={'Choose an employee'}
            onSelect={(v) => {
              setQuery({userId: v?.id, userName: v?.lastNameAndFirstNameWithSpace});
            }}
            renderDropdownItem={i => <div>
              <TextHighlighter data={i.lastNameAndFirstNameWithSpace} compareString={query.userName}/>
              <div className={'position_person'}>
                {i.positionName}
              </div>
            </div> }
            value={query.userName}
            onChange={(e) => {
              setQuery({userName: e});
            }}
            uniqueElement={i => i.id === query.userId}
            notFoundContent={{title: 'No results found', description: 'Please try searching with another name'}}
            onClear={() => setQuery({userName: '', userId: 0})}/>
        }
        {isRoleIdExist && !typingMode &&
          <div className={'role_actions_buttons'}>
            <Button className={'buttonWithIcon'} theme={{variant: 'secondary', color: 'theme'}} onClick={() => setTypingMode(true)}>
              <DraftIcon/>
            </Button>
            <Button className={'buttonWithIcon'} theme={{variant: 'secondary', color: 'red'}} onClick={() => deleteRole()}>
              <DeleteIcon/>
            </Button>
          </div>
        }
        {typingMode &&
          <div className={'role_actions_buttons'}>
            <Button onClick={() => setTypingMode(false)} theme={{variant: 'neutral', color: 'grey'}}>
              Cancel
            </Button>
            <Button disabled={(!query.userId && !isRoleIdExist) || props.role.actingId === query.userId} onClick={handleRole} theme={{variant: 'secondary', color: 'theme'}}>
              Save
            </Button>
          </div>
        }
      </div>


    </div>
  );
});
